const colors: any = {
    1: {
        id: 1,
        hsl: 'hsl(72, 100%, 50%)',
        hex: '#CCFF00',
        rgb: 'rgb(204, 255, 0)',
    },
    2: {
        id: 2,
        hsl: 'hsl(60, 100%, 40%)',
        hex: '#CCCC00',
        rgb: 'rgb(204, 204, 0)',
    },
    3: {
        id: 3,
        hsl: 'hsl(45, 100%, 40%)',
        hex: '#CC9900',
        rgb: 'rgb(204, 153, 0)',
    },
    4: {
        id: 4,
        hsl: 'hsl(30, 100%, 40%)',
        hex: '#CC6600',
        rgb: 'rgb(204, 102, 0)',
    },
    5: {
        id: 5,
        hsl: 'hsl(15, 100%, 40%)',
        hex: '#CC3300',
        rgb: 'rgb(204, 51, 0)',
    },
    6: {
        id: 6,
        hsl: 'hsl(0, 100%, 40%)',
        hex: '#CC0000',
        rgb: 'rgb(204, 0, 0)',
    },
    7: {
        id: 7,
        hsl: 'hsl(0, 100%, 20%)',
        hex: '#660000',
        rgb: 'rgb(102, 0, 0)',
    },
    8: {
        id: 8,
        hsl: 'hsl(30, 100%, 20%)',
        hex: '#663300',
        rgb: 'rgb(102, 51, 0)',
    },
    9: {
        id: 9,
        hsl: 'hsl(60, 100%, 20%)',
        hex: '#666600',
        rgb: 'rgb(102, 102, 0)',
    },
    10: {
        id: 10,
        hsl: 'hsl(80, 100%, 30%)',
        hex: '#669900',
        rgb: 'rgb(102, 153, 0)',
    },
    11: {
        id: 11,
        hsl: 'hsl(90, 100%, 40%)',
        hex: '#66CC00',
        rgb: 'rgb(102, 204, 0)',
    },
    12: {
        id: 12,
        hsl: 'hsl(96, 100%, 50%)',
        hex: '#66FF00',
        rgb: 'rgb(102, 255, 0)',
    },
    13: {
        id: 13,
        hsl: 'hsl(120, 100%, 50%)',
        hex: '#00FF00',
        rgb: 'rgb(0, 255, 0)',
    },
    14: {
        id: 14,
        hsl: 'hsl(120, 100%, 40%)',
        hex: '#00CC00',
        rgb: 'rgb(0, 204, 0)',
    },
    15: {
        id: 15,
        hsl: 'hsl(120, 100%, 30%)',
        hex: '#009900',
        rgb: 'rgb(0, 153, 0)',
    },
    16: {
        id: 16,
        hsl: 'hsl(120, 100%, 20%)',
        hex: '#006600',
        rgb: 'rgb(0, 102, 0)',
    },
    17: {
        id: 17,
        hsl: 'hsl(120, 100%, 10%)',
        hex: '#003300',
        rgb: 'rgb(0, 51, 0)',
    },
    18: {
        id: 18,
        hsl: 'hsl(0, 0%, 0%)',
        hex: '#000000',
        rgb: 'rgb(0, 0, 0)',
    },
    19: {
        id: 19,
        hsl: 'hsl(75, 100%, 60%)',
        hex: '#CCFF33',
        rgb: 'rgb(204, 255, 51)',
    },
    20: {
        id: 20,
        hsl: 'hsl(60, 60%, 50%)',
        hex: '#CCCC33',
        rgb: 'rgb(204, 204, 51)',
    },
    21: {
        id: 21,
        hsl: 'hsl(40, 60%, 50%)',
        hex: '#CC9933',
        rgb: 'rgb(204, 153, 51)',
    },
    22: {
        id: 22,
        hsl: 'hsl(20, 60%, 50%)',
        hex: '#CC6633',
        rgb: 'rgb(204, 102, 51)',
    },
    23: {
        id: 23,
        hsl: 'hsl(0, 60%, 50%)',
        hex: '#CC3333',
        rgb: 'rgb(204, 51, 51)',
    },
    24: {
        id: 24,
        hsl: 'hsl(345, 100%, 40%)',
        hex: '#CC0033',
        rgb: 'rgb(204, 0, 51)',
    },
    25: {
        id: 25,
        hsl: 'hsl(330, 100%, 20%)',
        hex: '#660033',
        rgb: 'rgb(102, 0, 51)',
    },
    26: {
        id: 26,
        hsl: 'hsl(0, 33%, 30%)',
        hex: '#663333',
        rgb: 'rgb(102, 51, 51)',
    },
    27: {
        id: 27,
        hsl: 'hsl(60, 33%, 30%)',
        hex: '#666633',
        rgb: 'rgb(102, 102, 51)',
    },
    28: {
        id: 28,
        hsl: 'hsl(90, 50%, 40%)',
        hex: '#669933',
        rgb: 'rgb(102, 153, 51)',
    },
    29: {
        id: 29,
        hsl: 'hsl(100, 60%, 50%)',
        hex: '#66CC33',
        rgb: 'rgb(102, 204, 51)',
    },
    30: {
        id: 30,
        hsl: 'hsl(105, 100%, 60%)',
        hex: '#66FF33',
        rgb: 'rgb(102, 255, 51)',
    },
    31: {
        id: 31,
        hsl: 'hsl(132, 100%, 50%)',
        hex: '#00FF33',
        rgb: 'rgb(0, 255, 51)',
    },
    32: {
        id: 32,
        hsl: 'hsl(135, 100%, 40%)',
        hex: '#00CC33',
        rgb: 'rgb(0, 204, 51)',
    },
    33: {
        id: 33,
        hsl: 'hsl(140, 100%, 30%)',
        hex: '#009933',
        rgb: 'rgb(0, 153, 51)',
    },
    34: {
        id: 34,
        hsl: 'hsl(150, 100%, 20%)',
        hex: '#006633',
        rgb: 'rgb(0, 102, 51)',
    },
    35: {
        id: 35,
        hsl: 'hsl(180, 100%, 10%)',
        hex: '#003333',
        rgb: 'rgb(0, 51, 51)',
    },
    36: {
        id: 36,
        hsl: 'hsl(240, 100%, 10%)',
        hex: '#000033',
        rgb: 'rgb(0, 0, 51)',
    },
    37: {
        id: 37,
        hsl: 'hsl(80, 100%, 70%)',
        hex: '#CCFF66',
        rgb: 'rgb(204, 255, 102)',
    },
    38: {
        id: 38,
        hsl: 'hsl(60, 50%, 60%)',
        hex: '#CCCC66',
        rgb: 'rgb(204, 204, 102)',
    },
    39: {
        id: 39,
        hsl: 'hsl(30, 50%, 60%)',
        hex: '#CC9966',
        rgb: 'rgb(204, 153, 102)',
    },
    40: {
        id: 40,
        hsl: 'hsl(0, 50%, 60%)',
        hex: '#CC6666',
        rgb: 'rgb(204, 102, 102)',
    },
    41: {
        id: 41,
        hsl: 'hsl(340, 60%, 50%)',
        hex: '#CC3366',
        rgb: 'rgb(204, 51, 102)',
    },
    42: {
        id: 42,
        hsl: 'hsl(330, 100%, 40%)',
        hex: '#CC0066',
        rgb: 'rgb(204, 0, 102)',
    },
    43: {
        id: 43,
        hsl: 'hsl(300, 100%, 20%)',
        hex: '#660066',
        rgb: 'rgb(102, 0, 102)',
    },
    44: {
        id: 44,
        hsl: 'hsl(300, 33%, 30%)',
        hex: '#663366',
        rgb: 'rgb(102, 51, 102)',
    },
    45: {
        id: 45,
        hsl: 'hsl(0, 0%, 40%)',
        hex: '#666666',
        rgb: 'rgb(102, 102, 102)',
    },
    46: {
        id: 46,
        hsl: 'hsl(120, 20%, 50%)',
        hex: '#669966',
        rgb: 'rgb(102, 153, 102)',
    },
    47: {
        id: 47,
        hsl: 'hsl(120, 50%, 60%)',
        hex: '#66CC66',
        rgb: 'rgb(102, 204, 102)',
    },
    48: {
        id: 48,
        hsl: 'hsl(120, 100%, 70%)',
        hex: '#66FF66',
        rgb: 'rgb(102, 255, 102)',
    },
    49: {
        id: 49,
        hsl: 'hsl(144, 100%, 50%)',
        hex: '#00FF66',
        rgb: 'rgb(0, 255, 102)',
    },
    50: {
        id: 50,
        hsl: 'hsl(150, 100%, 40%)',
        hex: '#00CC66',
        rgb: 'rgb(0, 204, 102)',
    },
    51: {
        id: 51,
        hsl: 'hsl(160, 100%, 30%)',
        hex: '#009966',
        rgb: 'rgb(0, 153, 102)',
    },
    52: {
        id: 52,
        hsl: 'hsl(180, 100%, 20%)',
        hex: '#006666',
        rgb: 'rgb(0, 102, 102)',
    },
    53: {
        id: 53,
        hsl: 'hsl(210, 100%, 20%)',
        hex: '#003366',
        rgb: 'rgb(0, 51, 102)',
    },
    54: {
        id: 54,
        hsl: 'hsl(240, 100%, 20%)',
        hex: '#000066',
        rgb: 'rgb(0, 0, 102)',
    },
    55: {
        id: 55,
        hsl: 'hsl(90, 100%, 80%)',
        hex: '#CCFF99',
        rgb: 'rgb(204, 255, 153)',
    },
    56: {
        id: 56,
        hsl: 'hsl(60, 33%, 70%)',
        hex: '#CCCC99',
        rgb: 'rgb(204, 204, 153)',
    },
    57: {
        id: 57,
        hsl: 'hsl(0, 33%, 70%)',
        hex: '#CC9999',
        rgb: 'rgb(204, 153, 153)',
    },
    58: {
        id: 58,
        hsl: 'hsl(330, 50%, 60%)',
        hex: '#CC6699',
        rgb: 'rgb(204, 102, 153)',
    },
    59: {
        id: 59,
        hsl: 'hsl(320, 60%, 50%)',
        hex: '#CC3399',
        rgb: 'rgb(204, 51, 153)',
    },
    60: {
        id: 60,
        hsl: 'hsl(315, 100%, 40%)',
        hex: '#CC0099',
        rgb: 'rgb(204, 0, 153)',
    },
    61: {
        id: 61,
        hsl: 'hsl(280, 100%, 30%)',
        hex: '#660099',
        rgb: 'rgb(102, 0, 153)',
    },
    62: {
        id: 62,
        hsl: 'hsl(270, 50%, 40%)',
        hex: '#663399',
        rgb: 'rgb(102, 51, 153)',
    },
    63: {
        id: 63,
        hsl: 'hsl(240, 20%, 50%)',
        hex: '#666699',
        rgb: 'rgb(102, 102, 153)',
    },
    64: {
        id: 64,
        hsl: 'hsl(180, 20%, 50%)',
        hex: '#669999',
        rgb: 'rgb(102, 153, 153)',
    },
    65: {
        id: 65,
        hsl: 'hsl(150, 50%, 60%)',
        hex: '#66CC99',
        rgb: 'rgb(102, 204, 153)',
    },
    66: {
        id: 66,
        hsl: 'hsl(140, 100%, 70%)',
        hex: '#66FF99',
        rgb: 'rgb(102, 255, 153)',
    },
    67: {
        id: 67,
        hsl: 'hsl(156, 100%, 50%)',
        hex: '#00FF99',
        rgb: 'rgb(0, 255, 153)',
    },
    68: {
        id: 68,
        hsl: 'hsl(165, 100%, 40%)',
        hex: '#00CC99',
        rgb: 'rgb(0, 204, 153)',
    },
    69: {
        id: 69,
        hsl: 'hsl(180, 100%, 30%)',
        hex: '#009999',
        rgb: 'rgb(0, 153, 153)',
    },
    70: {
        id: 70,
        hsl: 'hsl(200, 100%, 30%)',
        hex: '#006699',
        rgb: 'rgb(0, 102, 153)',
    },
    71: {
        id: 71,
        hsl: 'hsl(220, 100%, 30%)',
        hex: '#003399',
        rgb: 'rgb(0, 51, 153)',
    },
    72: {
        id: 72,
        hsl: 'hsl(240, 100%, 30%)',
        hex: '#000099',
        rgb: 'rgb(0, 0, 153)',
    },
    73: {
        id: 73,
        hsl: 'hsl(120, 100%, 90%)',
        hex: '#CCFFCC',
        rgb: 'rgb(204, 255, 204)',
    },
    74: {
        id: 74,
        hsl: 'hsl(0, 0%, 80%)',
        hex: '#CCCCCC',
        rgb: 'rgb(204, 204, 204)',
    },
    75: {
        id: 75,
        hsl: 'hsl(300, 33%, 70%)',
        hex: '#CC99CC',
        rgb: 'rgb(204, 153, 204)',
    },
    76: {
        id: 76,
        hsl: 'hsl(300, 50%, 60%)',
        hex: '#CC66CC',
        rgb: 'rgb(204, 102, 204)',
    },
    77: {
        id: 77,
        hsl: 'hsl(300, 60%, 50%)',
        hex: '#CC33CC',
        rgb: 'rgb(204, 51, 204)',
    },
    78: {
        id: 78,
        hsl: 'hsl(300, 100%, 40%)',
        hex: '#CC00CC',
        rgb: 'rgb(204, 0, 204)',
    },
    79: {
        id: 79,
        hsl: 'hsl(270, 100%, 40%)',
        hex: '#6600CC',
        rgb: 'rgb(102, 0, 204)',
    },
    80: {
        id: 80,
        hsl: 'hsl(260, 60%, 50%)',
        hex: '#6633CC',
        rgb: 'rgb(102, 51, 204)',
    },
    81: {
        id: 81,
        hsl: 'hsl(240, 50%, 60%)',
        hex: '#6666CC',
        rgb: 'rgb(102, 102, 204)',
    },
    82: {
        id: 82,
        hsl: 'hsl(210, 50%, 60%)',
        hex: '#6699CC',
        rgb: 'rgb(102, 153, 204)',
    },
    83: {
        id: 83,
        hsl: 'hsl(180, 50%, 60%)',
        hex: '#66CCCC',
        rgb: 'rgb(102, 204, 204)',
    },
    84: {
        id: 84,
        hsl: 'hsl(160, 100%, 70%)',
        hex: '#66FFCC',
        rgb: 'rgb(102, 255, 204)',
    },
    85: {
        id: 85,
        hsl: 'hsl(168, 100%, 50%)',
        hex: '#00FFCC',
        rgb: 'rgb(0, 255, 204)',
    },
    86: {
        id: 86,
        hsl: 'hsl(180, 100%, 40%)',
        hex: '#00CCCC',
        rgb: 'rgb(0, 204, 204)',
    },
    87: {
        id: 87,
        hsl: 'hsl(195, 100%, 40%)',
        hex: '#0099CC',
        rgb: 'rgb(0, 153, 204)',
    },
    88: {
        id: 88,
        hsl: 'hsl(210, 100%, 40%)',
        hex: '#0066CC',
        rgb: 'rgb(0, 102, 204)',
    },
    89: {
        id: 89,
        hsl: 'hsl(225, 100%, 40%)',
        hex: '#0033CC',
        rgb: 'rgb(0, 51, 204)',
    },
    90: {
        id: 90,
        hsl: 'hsl(240, 100%, 40%)',
        hex: '#0000CC',
        rgb: 'rgb(0, 0, 204)',
    },
    91: {
        id: 91,
        hsl: 'hsl(180, 100%, 90%)',
        hex: '#CCFFFF',
        rgb: 'rgb(204, 255, 255)',
    },
    92: {
        id: 92,
        hsl: 'hsl(240, 100%, 90%)',
        hex: '#CCCCFF',
        rgb: 'rgb(204, 204, 255)',
    },
    93: {
        id: 93,
        hsl: 'hsl(270, 100%, 80%)',
        hex: '#CC99FF',
        rgb: 'rgb(204, 153, 255)',
    },
    94: {
        id: 94,
        hsl: 'hsl(280, 100%, 70%)',
        hex: '#CC66FF',
        rgb: 'rgb(204, 102, 255)',
    },
    95: {
        id: 95,
        hsl: 'hsl(285, 100%, 60%)',
        hex: '#CC33FF',
        rgb: 'rgb(204, 51, 255)',
    },
    96: {
        id: 96,
        hsl: 'hsl(288, 100%, 50%)',
        hex: '#CC00FF',
        rgb: 'rgb(204, 0, 255)',
    },
    97: {
        id: 97,
        hsl: 'hsl(264, 100%, 50%)',
        hex: '#6600FF',
        rgb: 'rgb(102, 0, 255)',
    },
    98: {
        id: 98,
        hsl: 'hsl(255, 100%, 60%)',
        hex: '#6633FF',
        rgb: 'rgb(102, 51, 255)',
    },
    99: {
        id: 99,
        hsl: 'hsl(240, 100%, 70%)',
        hex: '#6666FF',
        rgb: 'rgb(102, 102, 255)',
    },
    100: {
        id: 100,
        hsl: 'hsl(220, 100%, 70%)',
        hex: '#6699FF',
        rgb: 'rgb(102, 153, 255)',
    },
    101: {
        id: 101,
        hsl: 'hsl(200, 100%, 70%)',
        hex: '#66CCFF',
        rgb: 'rgb(102, 204, 255)',
    },
    102: {
        id: 102,
        hsl: 'hsl(180, 100%, 70%)',
        hex: '#66FFFF',
        rgb: 'rgb(102, 255, 255)',
    },
    103: {
        id: 103,
        hsl: 'hsl(180, 100%, 50%)',
        hex: '#00FFFF',
        rgb: 'rgb(0, 255, 255)',
    },
    104: {
        id: 104,
        hsl: 'hsl(192, 100%, 50%)',
        hex: '#00CCFF',
        rgb: 'rgb(0, 204, 255)',
    },
    105: {
        id: 105,
        hsl: 'hsl(204, 100%, 50%)',
        hex: '#0099FF',
        rgb: 'rgb(0, 153, 255)',
    },
    106: {
        id: 106,
        hsl: 'hsl(216, 100%, 50%)',
        hex: '#0066FF',
        rgb: 'rgb(0, 102, 255)',
    },
    107: {
        id: 107,
        hsl: 'hsl(228, 100%, 50%)',
        hex: '#0033FF',
        rgb: 'rgb(0, 51, 255)',
    },
    108: {
        id: 108,
        hsl: 'hsl(240, 100%, 50%)',
        hex: '#0000FF',
        rgb: 'rgb(0, 0, 255)',
    },
    109: {
        id: 109,
        hsl: 'hsl(0, 0%, 100%)',
        hex: '#FFFFFF',
        rgb: 'rgb(255, 255, 255)',
    },
    110: {
        id: 110,
        hsl: 'hsl(300, 100%, 90%)',
        hex: '#FFCCFF',
        rgb: 'rgb(255, 204, 255)',
    },
    111: {
        id: 111,
        hsl: 'hsl(300, 100%, 80%)',
        hex: '#FF99FF',
        rgb: 'rgb(255, 153, 255)',
    },
    112: {
        id: 112,
        hsl: 'hsl(300, 100%, 70%)',
        hex: '#FF66FF',
        rgb: 'rgb(255, 102, 255)',
    },
    113: {
        id: 113,
        hsl: 'hsl(300, 100%, 60%)',
        hex: '#FF33FF',
        rgb: 'rgb(255, 51, 255)',
    },
    114: {
        id: 114,
        hsl: 'hsl(300, 100%, 50%)',
        hex: '#FF00FF',
        rgb: 'rgb(255, 0, 255)',
    },
    115: {
        id: 115,
        hsl: 'hsl(276, 100%, 50%)',
        hex: '#9900FF',
        rgb: 'rgb(153, 0, 255)',
    },
    116: {
        id: 116,
        hsl: 'hsl(270, 100%, 60%)',
        hex: '#9933FF',
        rgb: 'rgb(153, 51, 255)',
    },
    117: {
        id: 117,
        hsl: 'hsl(260, 100%, 70%)',
        hex: '#9966FF',
        rgb: 'rgb(153, 102, 255)',
    },
    118: {
        id: 118,
        hsl: 'hsl(240, 100%, 80%)',
        hex: '#9999FF',
        rgb: 'rgb(153, 153, 255)',
    },
    119: {
        id: 119,
        hsl: 'hsl(210, 100%, 80%)',
        hex: '#99CCFF',
        rgb: 'rgb(153, 204, 255)',
    },
    120: {
        id: 120,
        hsl: 'hsl(180, 100%, 80%)',
        hex: '#99FFFF',
        rgb: 'rgb(153, 255, 255)',
    },
    121: {
        id: 121,
        hsl: 'hsl(180, 100%, 60%)',
        hex: '#33FFFF',
        rgb: 'rgb(51, 255, 255)',
    },
    122: {
        id: 122,
        hsl: 'hsl(195, 100%, 60%)',
        hex: '#33CCFF',
        rgb: 'rgb(51, 204, 255)',
    },
    123: {
        id: 123,
        hsl: 'hsl(210, 100%, 60%)',
        hex: '#3399FF',
        rgb: 'rgb(51, 153, 255)',
    },
    124: {
        id: 124,
        hsl: 'hsl(225, 100%, 60%)',
        hex: '#3366FF',
        rgb: 'rgb(51, 102, 255)',
    },
    125: {
        id: 125,
        hsl: 'hsl(240, 100%, 60%)',
        hex: '#3333FF',
        rgb: 'rgb(51, 51, 255)',
    },
    126: {
        id: 126,
        hsl: 'hsl(252, 100%, 50%)',
        hex: '#3300FF',
        rgb: 'rgb(51, 0, 255)',
    },
    127: {
        id: 127,
        hsl: 'hsl(60, 100%, 90%)',
        hex: '#FFFFCC',
        rgb: 'rgb(255, 255, 204)',
    },
    128: {
        id: 128,
        hsl: 'hsl(0, 100%, 90%)',
        hex: '#FFCCCC',
        rgb: 'rgb(255, 204, 204)',
    },
    129: {
        id: 129,
        hsl: 'hsl(330, 100%, 80%)',
        hex: '#FF99CC',
        rgb: 'rgb(255, 153, 204)',
    },
    130: {
        id: 130,
        hsl: 'hsl(320, 100%, 70%)',
        hex: '#FF66CC',
        rgb: 'rgb(255, 102, 204)',
    },
    131: {
        id: 131,
        hsl: 'hsl(315, 100%, 60%)',
        hex: '#FF33CC',
        rgb: 'rgb(255, 51, 204)',
    },
    132: {
        id: 132,
        hsl: 'hsl(312, 100%, 50%)',
        hex: '#FF00CC',
        rgb: 'rgb(255, 0, 204)',
    },
    133: {
        id: 133,
        hsl: 'hsl(285, 100%, 40%)',
        hex: '#9900CC',
        rgb: 'rgb(153, 0, 204)',
    },
    134: {
        id: 134,
        hsl: 'hsl(280, 60%, 50%)',
        hex: '#9933CC',
        rgb: 'rgb(153, 51, 204)',
    },
    135: {
        id: 135,
        hsl: 'hsl(270, 50%, 60%)',
        hex: '#9966CC',
        rgb: 'rgb(153, 102, 204)',
    },
    136: {
        id: 136,
        hsl: 'hsl(240, 33%, 70%)',
        hex: '#9999CC',
        rgb: 'rgb(153, 153, 204)',
    },
    137: {
        id: 137,
        hsl: 'hsl(180, 33%, 70%)',
        hex: '#99CCCC',
        rgb: 'rgb(153, 204, 204)',
    },
    138: {
        id: 138,
        hsl: 'hsl(150, 100%, 80%)',
        hex: '#99FFCC',
        rgb: 'rgb(153, 255, 204)',
    },
    139: {
        id: 139,
        hsl: 'hsl(165, 100%, 60%)',
        hex: '#33FFCC',
        rgb: 'rgb(51, 255, 204)',
    },
    140: {
        id: 140,
        hsl: 'hsl(180, 60%, 50%)',
        hex: '#33CCCC',
        rgb: 'rgb(51, 204, 204)',
    },
    141: {
        id: 141,
        hsl: 'hsl(200, 60%, 50%)',
        hex: '#3399CC',
        rgb: 'rgb(51, 153, 204)',
    },
    142: {
        id: 142,
        hsl: 'hsl(220, 60%, 50%)',
        hex: '#3366CC',
        rgb: 'rgb(51, 102, 204)',
    },
    143: {
        id: 143,
        hsl: 'hsl(240, 60%, 50%)',
        hex: '#3333CC',
        rgb: 'rgb(51, 51, 204)',
    },
    144: {
        id: 144,
        hsl: 'hsl(255, 100%, 40%)',
        hex: '#3300CC',
        rgb: 'rgb(51, 0, 204)',
    },
    145: {
        id: 145,
        hsl: 'hsl(60, 100%, 80%)',
        hex: '#FFFF99',
        rgb: 'rgb(255, 255, 153)',
    },
    146: {
        id: 146,
        hsl: 'hsl(30, 100%, 80%)',
        hex: '#FFCC99',
        rgb: 'rgb(255, 204, 153)',
    },
    147: {
        id: 147,
        hsl: 'hsl(0, 100%, 80%)',
        hex: '#FF9999',
        rgb: 'rgb(255, 153, 153)',
    },
    148: {
        id: 148,
        hsl: 'hsl(340, 100%, 70%)',
        hex: '#FF6699',
        rgb: 'rgb(255, 102, 153)',
    },
    149: {
        id: 149,
        hsl: 'hsl(330, 100%, 60%)',
        hex: '#FF3399',
        rgb: 'rgb(255, 51, 153)',
    },
    150: {
        id: 150,
        hsl: 'hsl(324, 100%, 50%)',
        hex: '#FF0099',
        rgb: 'rgb(255, 0, 153)',
    },
    151: {
        id: 151,
        hsl: 'hsl(300, 100%, 30%)',
        hex: '#990099',
        rgb: 'rgb(153, 0, 153)',
    },
    152: {
        id: 152,
        hsl: 'hsl(300, 50%, 40%)',
        hex: '#993399',
        rgb: 'rgb(153, 51, 153)',
    },
    153: {
        id: 153,
        hsl: 'hsl(300, 20%, 50%)',
        hex: '#996699',
        rgb: 'rgb(153, 102, 153)',
    },
    154: {
        id: 154,
        hsl: 'hsl(0, 0%, 60%)',
        hex: '#999999',
        rgb: 'rgb(153, 153, 153)',
    },
    155: {
        id: 155,
        hsl: 'hsl(120, 33%, 70%)',
        hex: '#99CC99',
        rgb: 'rgb(153, 204, 153)',
    },
    156: {
        id: 156,
        hsl: 'hsl(120, 100%, 80%)',
        hex: '#99FF99',
        rgb: 'rgb(153, 255, 153)',
    },
    157: {
        id: 157,
        hsl: 'hsl(150, 100%, 60%)',
        hex: '#33FF99',
        rgb: 'rgb(51, 255, 153)',
    },
    158: {
        id: 158,
        hsl: 'hsl(160, 60%, 50%)',
        hex: '#33CC99',
        rgb: 'rgb(51, 204, 153)',
    },
    159: {
        id: 159,
        hsl: 'hsl(180, 50%, 40%)',
        hex: '#339999',
        rgb: 'rgb(51, 153, 153)',
    },
    160: {
        id: 160,
        hsl: 'hsl(210, 50%, 40%)',
        hex: '#336699',
        rgb: 'rgb(51, 102, 153)',
    },
    161: {
        id: 161,
        hsl: 'hsl(240, 50%, 40%)',
        hex: '#333399',
        rgb: 'rgb(51, 51, 153)',
    },
    162: {
        id: 162,
        hsl: 'hsl(260, 100%, 30%)',
        hex: '#330099',
        rgb: 'rgb(51, 0, 153)',
    },
    163: {
        id: 163,
        hsl: 'hsl(60, 100%, 70%)',
        hex: '#FFFF66',
        rgb: 'rgb(255, 255, 102)',
    },
    164: {
        id: 164,
        hsl: 'hsl(40, 100%, 70%)',
        hex: '#FFCC66',
        rgb: 'rgb(255, 204, 102)',
    },
    165: {
        id: 165,
        hsl: 'hsl(20, 100%, 70%)',
        hex: '#FF9966',
        rgb: 'rgb(255, 153, 102)',
    },
    166: {
        id: 166,
        hsl: 'hsl(0, 100%, 70%)',
        hex: '#FF6666',
        rgb: 'rgb(255, 102, 102)',
    },
    167: {
        id: 167,
        hsl: 'hsl(345, 100%, 60%)',
        hex: '#FF3366',
        rgb: 'rgb(255, 51, 102)',
    },
    168: {
        id: 168,
        hsl: 'hsl(336, 100%, 50%)',
        hex: '#FF0066',
        rgb: 'rgb(255, 0, 102)',
    },
    169: {
        id: 169,
        hsl: 'hsl(320, 100%, 30%)',
        hex: '#990066',
        rgb: 'rgb(153, 0, 102)',
    },
    170: {
        id: 170,
        hsl: 'hsl(330, 50%, 40%)',
        hex: '#993366',
        rgb: 'rgb(153, 51, 102)',
    },
    171: {
        id: 171,
        hsl: 'hsl(0, 20%, 50%)',
        hex: '#996666',
        rgb: 'rgb(153, 102, 102)',
    },
    172: {
        id: 172,
        hsl: 'hsl(60, 20%, 50%)',
        hex: '#999966',
        rgb: 'rgb(153, 153, 102)',
    },
    173: {
        id: 173,
        hsl: 'hsl(90, 50%, 60%)',
        hex: '#99CC66',
        rgb: 'rgb(153, 204, 102)',
    },
    174: {
        id: 174,
        hsl: 'hsl(100, 100%, 70%)',
        hex: '#99FF66',
        rgb: 'rgb(153, 255, 102)',
    },
    175: {
        id: 175,
        hsl: 'hsl(135, 100%, 60%)',
        hex: '#33FF66',
        rgb: 'rgb(51, 255, 102)',
    },
    176: {
        id: 176,
        hsl: 'hsl(140, 60%, 50%)',
        hex: '#33CC66',
        rgb: 'rgb(51, 204, 102)',
    },
    177: {
        id: 177,
        hsl: 'hsl(150, 50%, 40%)',
        hex: '#339966',
        rgb: 'rgb(51, 153, 102)',
    },
    178: {
        id: 178,
        hsl: 'hsl(180, 33%, 30%)',
        hex: '#336666',
        rgb: 'rgb(51, 102, 102)',
    },
    179: {
        id: 179,
        hsl: 'hsl(240, 33%, 30%)',
        hex: '#333366',
        rgb: 'rgb(51, 51, 102)',
    },
    180: {
        id: 180,
        hsl: 'hsl(270, 100%, 20%)',
        hex: '#330066',
        rgb: 'rgb(51, 0, 102)',
    },
    181: {
        id: 181,
        hsl: 'hsl(60, 100%, 60%)',
        hex: '#FFFF33',
        rgb: 'rgb(255, 255, 51)',
    },
    182: {
        id: 182,
        hsl: 'hsl(45, 100%, 60%)',
        hex: '#FFCC33',
        rgb: 'rgb(255, 204, 51)',
    },
    183: {
        id: 183,
        hsl: 'hsl(30, 100%, 60%)',
        hex: '#FF9933',
        rgb: 'rgb(255, 153, 51)',
    },
    184: {
        id: 184,
        hsl: 'hsl(15, 100%, 60%)',
        hex: '#FF6633',
        rgb: 'rgb(255, 102, 51)',
    },
    185: {
        id: 185,
        hsl: 'hsl(0, 100%, 60%)',
        hex: '#FF3333',
        rgb: 'rgb(255, 51, 51)',
    },
    186: {
        id: 186,
        hsl: 'hsl(348, 100%, 50%)',
        hex: '#FF0033',
        rgb: 'rgb(255, 0, 51)',
    },
    187: {
        id: 187,
        hsl: 'hsl(340, 100%, 30%)',
        hex: '#990033',
        rgb: 'rgb(153, 0, 51)',
    },
    188: {
        id: 188,
        hsl: 'hsl(0, 50%, 40%)',
        hex: '#993333',
        rgb: 'rgb(153, 51, 51)',
    },
    189: {
        id: 189,
        hsl: 'hsl(30, 50%, 40%)',
        hex: '#996633',
        rgb: 'rgb(153, 102, 51)',
    },
    190: {
        id: 190,
        hsl: 'hsl(60, 50%, 40%)',
        hex: '#999933',
        rgb: 'rgb(153, 153, 51)',
    },
    191: {
        id: 191,
        hsl: 'hsl(80, 60%, 50%)',
        hex: '#99CC33',
        rgb: 'rgb(153, 204, 51)',
    },
    192: {
        id: 192,
        hsl: 'hsl(90, 100%, 60%)',
        hex: '#99FF33',
        rgb: 'rgb(153, 255, 51)',
    },
    193: {
        id: 193,
        hsl: 'hsl(120, 100%, 60%)',
        hex: '#33FF33',
        rgb: 'rgb(51, 255, 51)',
    },
    194: {
        id: 194,
        hsl: 'hsl(120, 60%, 50%)',
        hex: '#33CC33',
        rgb: 'rgb(51, 204, 51)',
    },
    195: {
        id: 195,
        hsl: 'hsl(120, 50%, 40%)',
        hex: '#339933',
        rgb: 'rgb(51, 153, 51)',
    },
    196: {
        id: 196,
        hsl: 'hsl(120, 33%, 30%)',
        hex: '#336633',
        rgb: 'rgb(51, 102, 51)',
    },
    197: {
        id: 197,
        hsl: 'hsl(0, 0%, 20%)',
        hex: '#333333',
        rgb: 'rgb(51, 51, 51)',
    },
    198: {
        id: 198,
        hsl: 'hsl(300, 100%, 10%)',
        hex: '#330033',
        rgb: 'rgb(51, 0, 51)',
    },
    199: {
        id: 199,
        hsl: 'hsl(60, 100%, 50%)',
        hex: '#FFFF00',
        rgb: 'rgb(255, 255, 0)',
    },
    200: {
        id: 200,
        hsl: 'hsl(48, 100%, 50%)',
        hex: '#FFCC00',
        rgb: 'rgb(255, 204, 0)',
    },
    201: {
        id: 201,
        hsl: 'hsl(36, 100%, 50%)',
        hex: '#FF9900',
        rgb: 'rgb(255, 153, 0)',
    },
    202: {
        id: 202,
        hsl: 'hsl(24, 100%, 50%)',
        hex: '#FF6600',
        rgb: 'rgb(255, 102, 0)',
    },
    203: {
        id: 203,
        hsl: 'hsl(12, 100%, 50%)',
        hex: '#FF3300',
        rgb: 'rgb(255, 51, 0)',
    },
    204: {
        id: 204,
        hsl: 'hsl(0, 100%, 50%)',
        hex: '#FF0000',
        rgb: 'rgb(255, 0, 0)',
    },
    205: {
        id: 205,
        hsl: 'hsl(0, 100%, 30%)',
        hex: '#990000',
        rgb: 'rgb(153, 0, 0)',
    },
    206: {
        id: 206,
        hsl: 'hsl(20, 100%, 30%)',
        hex: '#993300',
        rgb: 'rgb(153, 51, 0)',
    },
    207: {
        id: 207,
        hsl: 'hsl(40, 100%, 30%)',
        hex: '#996600',
        rgb: 'rgb(153, 102, 0)',
    },
    208: {
        id: 208,
        hsl: 'hsl(60, 100%, 30%)',
        hex: '#999900',
        rgb: 'rgb(153, 153, 0)',
    },
    209: {
        id: 209,
        hsl: 'hsl(75, 100%, 40%)',
        hex: '#99CC00',
        rgb: 'rgb(153, 204, 0)',
    },
    210: {
        id: 210,
        hsl: 'hsl(84, 100%, 50%)',
        hex: '#99FF00',
        rgb: 'rgb(153, 255, 0)',
    },
    211: {
        id: 211,
        hsl: 'hsl(108, 100%, 50%)',
        hex: '#33FF00',
        rgb: 'rgb(51, 255, 0)',
    },
    212: {
        id: 212,
        hsl: 'hsl(105, 100%, 40%)',
        hex: '#33CC00',
        rgb: 'rgb(51, 204, 0)',
    },
    213: {
        id: 213,
        hsl: 'hsl(100, 100%, 30%)',
        hex: '#339900',
        rgb: 'rgb(51, 153, 0)',
    },
    214: {
        id: 214,
        hsl: 'hsl(90, 100%, 20%)',
        hex: '#336600',
        rgb: 'rgb(51, 102, 0)',
    },
    215: {
        id: 215,
        hsl: 'hsl(60, 100%, 10%)',
        hex: '#333300',
        rgb: 'rgb(51, 51, 0)',
    },
    216: {
        id: 216,
        hsl: 'hsl(0, 100%, 10%)',
        hex: '#330000',
        rgb: 'rgb(51, 0, 0)',
    },
};

export default colors;
